<script>
import { mapActions, mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";

export default {
	name: "config",
	data() {
		return {
			mode: "INSERT",
			isKepala: 1,
			myData: {},
			myOptions: {
				kriteria: umatOpt.kriteria,
				jk: umatOpt.jk,
				gol_darah: umatOpt.golDarah,
				hubungan: umatData.hubungan,
			},
			trigger: {
				keluargaKatolik: 0,
			},
			anggota: {
				hubungan_keluarga: "",
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			pastor: (state) => state.configuration.pastor,
		}),
	},
	watch: {
		// isLoading: function (val) {
		// 	if (val) {
		// 		this.$swal({ text: "Loading", allowOutsideClick: false });
		// 		this.$swal.showLoading();
		// 	} else {
		// 		this.$swal.close();
		// 	}
		// },
	},
	mounted() {
		this.findAll();
	},
	methods: {
		...mapActions({
			// insert: "configuration/insert",
			// update: "configuration/update",
			getPastor: "configuration/getPastor",
			savePastor: "configuration/savePastor",
			deletePastor: "configuration/deletePastor",
			setPastor: "configuration/setPastor",
		}),
		async findAll() {
			await this.$store.dispatch("configuration/getPastorAll");
		},
		async onSubmit() {
			await this.savePastor(this.myData).then(() => {
				this.$toast.success("Berhasil disimpan");
				this.findAll();
				this.$bvModal.hide("modal-pastor");
				this.myData = {};
			});
		},
		async onSetPastor(id) {
			await this.setPastor(id).then(() => {
				this.$toast.success("Berhasil disimpan");
				this.findAll();
			});
		},
		onDelete(id) {
			this.$swal({
				title: "Apakah anda yakin?",
				text: "Data tidak dapat dipulihkan kembali!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Ya, Hapus!",
				html: false,
				allowOutsideClick: false,
				preConfirm: () => {
					return this.deletePastor(id).then(
						(response) => {
							this.findAll();
							return Promise.resolve(response.data);
						},
						(error) => {
							this.$swal("Gagal!", "", "danger");
							return Promise.reject(error);
						}
					);
				},
			}).then((result) => {
				if (typeof result.value !== "undefined") {
					if (result.value) {
						this.$swal("Deleted!", result.value.message, "success");
					} else {
						this.$swal("Gagal!", result.value, "danger");
					}
				}
			});
		},
		async onEdit(id) {
			this.getPastor(id).then((response) => {
				this.$bvModal.show("modal-pastor");
				this.myData = response.data;
				console.log(response.data);
			});
		},
	},
};
</script>

<template>
	<div>
		<!-- <vue-fab
			mainBtnColor="#0071B3"
			:scrollAutoHide="false"
			size="big"
			:globalOptions="{ spacing: 50, delay: 0.05 }"
			icon="menu"
		>
			<fab-item
				@clickItem="handleSumbmit"
				:idx="0"
				title="Simpan"
				icon="save"
			/>
		</vue-fab> -->

		<Breadcrumbs title="Konfigurasi" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Pastor Penandatangan Dokumen :</h5>
							<hr />

							<b-skeleton-wrapper :loading="!isLoading">
								<b-skeleton-table
									:rows="5"
									:columns="4"
									:table-props="{ bordered: true, striped: true }"
									animation="throb"
								></b-skeleton-table>
							</b-skeleton-wrapper>

							<template v-if="!isLoading">
								<b-button
									variant="primary"
									size="sm"
									v-b-modal.modal-pastor
									><i class="fa fa-plus"></i> Tambah Pastor
									Paroki</b-button
								>

								<div class="table-responsive invoice-table">
									<table class="table table-bordered table-striped">
										<thead class="thead-light">
											<tr>
												<th class="text-center">No.</th>
												<th class="text-center">Nama</th>
												<th class="text-center">Pilih</th>
												<th class="text-center">Hapus</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(item, index) in pastor"
												:key="item.umat_uid"
											>
												<td class="text-center">{{ index + 1 }}</td>
												<td>{{ item.nama }}</td>

												<td class="text-center">
													<input
														class="radio_animated"
														:checked="item.status == 1"
														type="radio"
														value="1"
														@click="onSetPastor(item.id)"
													/>
												</td>
												<td class="text-center">
													<b-btn-group>
														<b-button
															size="xs"
															variant="dark"
															@click="onEdit(item.id)"
															v-b-tooltip.hover
															title="Edit"
														>
															<i class="fa fa-pencil"></i>
														</b-button>
														<b-button
															size="xs"
															variant="danger"
															@click="onDelete(item.id)"
															v-b-tooltip.hover
															title="Delete"
														>
															<i class="fa fa-times"></i>
														</b-button>
													</b-btn-group>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</template>
						</div>
					</px-card>
				</div>
			</div>
		</div>

		<b-modal id="modal-pastor" centered title="Form" hide-footer>
			<form @submit.prevent="onSubmit" id="form-data">
				<div class="form theme-form">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>Nama Pastor Paroki</label>
								<input
									v-model="myData.nama"
									name="nama"
									class="form-control"
									type="text"
									required
								/>
							</div>
						</div>
					</div>
					<hr />
					<div class="row">
						<div class="col">
							<div class="form-group mb-0">
								<b-button
									class="mr-3"
									type="submit"
									variant="primary"
									:disabled="isLoading"
									form="form-data"
									@clickItem="onSubmit"
								>
									<span
										v-show="isLoading"
										class="spinner-border spinner-border-sm"
									></span
									><i class="fa fa-fw fa-save" v-show="!isLoading"></i>
									Simpan
								</b-button>
							</div>
						</div>
					</div>
				</div>
			</form>
		</b-modal>
	</div>
</template>

<style scoped>
.myModal {
	padding: 20px;
	scroll-behavior: smooth;
}
::v-deep .vm--modal {
	overflow-y: auto;
}
.modal-card {
	margin: 0px;
}
</style>